import type { StatefulDiaryT } from '@/types/database/diaries';
import type { StatefulTrackerViewT } from '@/types/database/trackers';

export function extractTrackerById(diary: StatefulDiaryT, trackerId: string) {
	return diary?.trackers_view?.find((m) => m.tracker_id === trackerId) as StatefulTrackerViewT;
}
